var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"button",attrs:{"color":_vm.color,"flat":"","icon":""},on:{"click":function($event){$event.stopPropagation();return _vm.action($event)}}},[_c('v-icon',{staticClass:"icon"},[_vm._v(_vm._s(_vm.icon))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }